import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 bg-pure-black relative overflow-hidden border-t border-white/5" data-id="element-222">
      {/* Emerald Glow Background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-emerald-glow/10 rounded-full blur-[120px] pointer-events-none" data-id="element-223" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="max-w-4xl mx-auto bg-dark-gray/80 backdrop-blur-sm rounded-2xl p-10 md:p-16 border border-emerald-glow/30 text-center relative overflow-hidden" data-id="element-225">
          {/* Top accent line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-emerald-glow to-transparent opacity-70" data-id="element-226" />

          <div className="w-20 h-20 mx-auto bg-pure-black rounded-full flex items-center justify-center mb-8 border border-emerald-glow/50 shadow-emerald" data-id="element-227">
            <ShieldCheck className="w-10 h-10 text-emerald-glow" data-id="element-228" />
          </div>

          <h2 className="text-3xl md:text-5xl font-black text-electric-yellow mb-8 uppercase tracking-wide" data-id="element-229">
            Nuestra Garantía
          </h2>

          <p className="text-xl md:text-2xl text-white leading-relaxed font-medium" data-id="element-230">
            Si en los primeros 90 días no ves un aumento medible en llamadas y
            clientes nuevos, trabajamos gratis hasta que lo consigas.{' '}
            <br className="hidden md:block" data-id="element-231" />
            <span className="text-emerald-glow font-bold mt-4 block" data-id="element-232">
              Sin letra pequeña. Sin excusas.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}